export const services = [
  {
    title: 'HVAC Design & Build',
    description:
      'Turn-key HVAC design, engineering, installation, and commissioning for new construction and retrofits.',
    icon: 'DesignServices',
  },
  {
    title: 'Mechanical Piping & Ductwork',
    description:
      'Fabrication and installation of steel, copper, and specialty piping plus precision sheet-metal ductwork.',
    icon: 'Plumbing',
  },
  {
    title: 'Specialized Equipment',
    description:
      'Chillers, boilers, cooling towers, generator cooling, and packaged equipment replacements.',
    icon: 'PrecisionManufacturing',
  },
  {
    title: 'Systems Integration & Controls',
    description:
      'DDC/BMS integration, insulation, testing, and balancing for high-reliability performance.',
    icon: 'SettingsEthernet',
  },
  {
    title: 'Critical Environments',
    description:
      'Computer rooms, laboratories, hospitals, and high-demand environments requiring tight tolerances.',
    icon: 'Lan',
  },
];
